import { Component, HostBinding, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { FiContenteditableSimpleTextPanelRootDirective } from '../fi-contenteditable-simple-text-panel-handler/fi-contenteditable-simple-text-panel-root.directive';

@Component({
    selector: 'fi-editor-page',
    templateUrl: './fi-editor-page.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fi-editor-page.component.scss'],
    providers: [
        {
            provide: FiContenteditableSimpleTextPanelRootDirective,
            useFactory: (component: FiEditorPageComponent) => component.contenteditableSimpleTextPanelRoot,
            deps: [FiEditorPageComponent],
        },
    ],
    standalone: false,
})
export class FiEditorPageComponent {
    @ViewChild(FiContenteditableSimpleTextPanelRootDirective, { static: false })
    contenteditableSimpleTextPanelRoot: FiContenteditableSimpleTextPanelRootDirective;

    @Input() showSidebar: boolean = true;
    @Input() sideBarPositioning: 'absolute' | 'static' = 'absolute';

    @HostBinding('class.fi-editor-page-sidebar-positioning-static')
    get isSideBarPositioningStatic() {
        return this.sideBarPositioning === 'static';
    }

    @HostBinding('class.fi-editor-page-no-sidebar')
    get isNoSideBar() {
        return !this.showSidebar;
    }
}
